import React, { useCallback, useState } from "react";
import { getBlogTagsAPI } from "../../api/GetTags";
import MiniArticle from "../mini/MiniArticle";
import getOneImageFromSections from "../../utils/getFeturedImageForPosts";
import { useQuery } from "@tanstack/react-query";
import http from "../../redux/http";
import Loader from "../mini/Loader";
import { useHistory } from "react-router-dom";
import * as H from "./Home.styled";

const PostsByTags = () => {
  const history = useHistory();
  const [postsByTags, setPostsByTag] = useState([]);

  const fetchPosts = useCallback(async (tags) => {
    await http
      .get("/blog_posts", {
        params: {
          size: tags.length,
          page: 1,
          tag: tags.join(","),
        },
      })
      .then(({ data }) => {
        setPostsByTag(data.data.posts?.slice(0, 4));
      });
  }, []);

  const { isLoading } = useQuery({
    queryKey: ["GetPostByTags"],
    queryFn: () =>
      getBlogTagsAPI({
        size: 4,
        page: 1,
        type: "keyword",
        category: "following",
      }),
    select: ({ data }) => data.data.tags,
    onSuccess: (tags) => fetchPosts(tags),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        postsByTags.length > 0 && (
          <H.HomeSidebarWrapper>
            <H.HomeTitle>Posts Based on Tags I Follow</H.HomeTitle>
            {postsByTags.map((post, i) => (
              <MiniArticle
                key={i}
                id={post.id}
                title={post.title}
                imageUrl={
                  post?.imageUrl || getOneImageFromSections(post?.sections)
                }
              />
            ))}
            {postsByTags.length > 5 && <H.ViewAll>View All</H.ViewAll>}
          </H.HomeSidebarWrapper>
        )
      )}
    </>
  );
};

export default PostsByTags;
